export function generateUrlParam(value) {
  if (typeof value !== "string") {
    return "";
  }
  // Remplacement des caractères spéciaux et accents
  let newValue = value
    .replace(/[^\w\s]/gi, "-")
    .toLowerCase()
    .replace(/[-\s]+/g, "-"); // Suppression des espaces et des tirets multiples
  // Remplacement des lettres accentuées et additionnels
  newValue = newValue
    .replace(/é/g, "e")
    .replace(/è/g, "e")
    .replace(/ê/g, "e")
    .replace(/â/g, "a")
    .replace(/à/g, "a")
    .replace(/ô/g, "o")
    .replace(/ï/g, "i")
    .replace(/ç/g, "c")
    .replace(/ù/g, "u");
  return newValue;
}
